import Button from "@/Components/Button/Button";
import Modal, { ModalProps } from "@/Components/Modal/Modal";
import SelectBox from "@/Components/Select/SelectBox";
import { useModalMeta } from "@/shared/atoms/useModal";
import useCouriersHook from "@/shared/hooks/useCouriersHook";
import { CmsUsersResponse } from "@/shared/utils/interfaces";
import { useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import Pin from "../Layout/Pin";

export type CheckInAction = "checkIn" | "checkOut";

const PersonnelCheckInModal = ({ onExit }: ModalProps) => {
  const { t } = useTranslation("", { keyPrefix: "personnelCheckIn" });
  const [{ action, onConfirm }] = useModalMeta();
  const personnel = useCouriersHook();
  const [selected, setSelected] = useState<CmsUsersResponse | undefined>();
  const [askPinCode, setAskPinCode] = useState<boolean>(false);

  const handleConfirm = () => {
    if (selected.has_pincode) {
      setAskPinCode(true);
    } else {
      onConfirm(selected, action);
      onExit();
    }
  };

  const handlePinSubmit = (pinCode: number[]) => {
    onConfirm(selected, action, pinCode);
    onExit();
  };

  if (askPinCode) {
    return (
      <Modal width={{ _: "90%", md: "40%" }} onExit={onExit}>
        <Pin onSubmit={handlePinSubmit} />
      </Modal>
    );
  }

  return (
    <Modal width={{ _: "90%", md: "40%" }} onExit={onExit}>
      <div className="mb-[2rem] text-2xl font-semibold">
        {action === "checkIn"
          ? t("selectPersonnelCheckIn")
          : t("selectPersonnelCheckOut")}
      </div>
      <div className="mb-12">
        <Row>
          {personnel.map((emp) => (
            <Col xs={6} md={4} key={emp.item_id}>
              <SelectBox
                onClick={() => setSelected(emp)}
                active={emp.item_id === selected?.item_id}
              >
                {emp.name}
              </SelectBox>
            </Col>
          ))}
        </Row>
      </div>
      <div className="flex gap-[1rem]">
        <Button variant="secondary" onClick={onExit}>
          {t("cancel")}
        </Button>
        <Button onClick={handleConfirm} isDisabled={!selected}>
          {action === "checkIn" ? t("checkIn") : t("checkOut")}
        </Button>
      </div>
    </Modal>
  );
};

export default PersonnelCheckInModal;
